import type { FC } from 'react'

import '../../css/Pagination.scss'
import { Select } from 'antd'

import Arrow from './../Icons/Arrow/Arrow'
import PaginationList from './PaginationList/PaginationList'

const { Option } = Select

interface IPaginationProps {
  total?: number
  size: number
  currentPage: number
  setCurrentPage: (number: number) => void
  setSizePage: (number: number) => void
  classList?: string
  pageSizeOptions: number[]
}

const Pagination: FC<IPaginationProps> = ({
  total,
  size,
  currentPage,
  setCurrentPage,
  setSizePage,
  classList,
  pageSizeOptions
}) => {
  const checkMaxPage = (total: number, size: number): number => {
    return Math.ceil(total / size)
  }

  return (
    <>
      {total === undefined ? (
        ''
      ) : (
        <div className={`pagination ${classList}`}>
          <div className='total'>
            {`Result: ${currentPage * size - size + 1}-${currentPage * size} of ${total}`}
          </div>
          <div className='wrap-right'>
            <PaginationList
              setCurrentPage={setCurrentPage}
              currentPage={currentPage}
              countPage={checkMaxPage(total, size)}
            />
            <Select
              onChange={value => setSizePage(Number(value))}
              className='select-pagesize'
              defaultValue={pageSizeOptions[0]}
              style={{ width: 70 }}
              suffixIcon={<Arrow />}
            >
              {pageSizeOptions.map(size => {
                return (
                  <Option key={size} value={size}>
                    {size}
                  </Option>
                )
              })}
            </Select>
          </div>
        </div>
      )}
    </>
  )
}

export default Pagination
